import React from "react";
import "./CorporateList.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import Table from "react-bootstrap/Table";
import eyeTag from "../../../../assests/eyeTag.svg";
import search from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import rechargeIcon from "../../../../assests/rechargeIcon.svg";
import editIcon from "../../../../assests/edit.svg"; 
import { useNavigate, useParams } from "react-router-dom";
import redicon from "../../../../assests/redicon.svg";
import LoadingSpinner from "../../../Loading/component";

const CorporateListComponent = (props) => {
  const { id , corporateId} = useParams();
  const navigate = useNavigate();

  const handleHomeClick = () => navigate("/");
  const handleBackClick = () => navigate(-1);

  const handleBPUserDetails = (corporateId) => {
    navigate(`/home/customermanager/editcorporatedetails/${corporateId}`);
  };

  // Handle click on Total Users
  const handleTotalUsersClick = (corporateId, totalUsers) => {
    if (totalUsers > 0) {
      // Navigate to user management with corporate ID
      navigate(`/home/customermanager/bpmanagementlist/corporatemanagementuserdetails/${corporateId}`);
    }
  };

  // Handle click on Total Department
  const handleTotalDepartmentClick = (corporateId, totalDepartment) => {
    if (totalDepartment > 0) {
      // Navigate to department list with corporate ID
      navigate(`/home/customermanager/departments/${corporateId}`);
    }
  };

  // Handle click on Total Rule
  const handleTotalRuleClick = (corporateId, totalRule) => {
    // Navigate to rule management with corporate ID
    navigate(`/home/customermanager/corporate/rules/${corporateId}`);
  };

  // Handle click on Edit icon to go to corporate dashboard
  const handleEditCorporate = (corporateId) => {
    navigate(`/home/customermanager/corporatedashboard/${corporateId}`);
  };

  return (
    <div className="bp-management-container">
      <Sidebar />
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="bp-management-content">
          <>
            <div className="bp-management-header">
              <button onClick={handleBackClick} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>BP Management</h1>
            </div>

            <div className="bp-management-controls">
              <div className="bp-search-container">
                <input
                  type="search"
                  placeholder="Search by Cop. ID / Corporate name"
                  value={props.searchValue}
                  onChange={props.handleSearchInputChange}
                />
                {/* <button
                  className="bp-search-button"
                  onClick={props.handleFilterFranchisees}
                >
                  <img src={search} alt="Search" />
                </button> */}
              </div>

              <Button
                variant="contained"
                className="add-button"
                onClick={props.handleAddNewCorporate}
              >
                + Create New Corporate
              </Button>
            </div>

            <div className="bp-table-container">
              <div className="table-scroll-wrapper" ref={props.tableContainerRef}>
                <Table className="bp-table">
                  <thead>
                    <tr>
                      <th>Corp. ID</th>
                      <th>Corporate Name</th>
                      <th>Total Users</th>
                      <th>Total Department</th>
                      <th>Total Rule</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.filteredTagSeriesList?.length > 0 ? (
                      props.filteredTagSeriesList.map((item, index) => (
                        <tr key={item.id} className="bp-view">
                          <td>{item.corporateId}</td>
                          <td>{item.corporateName}</td>
                          
                          {/* Total Users - Clickable if > 0 */}
                          <td>
                            <span 
                              className={`total-count ${item.totalUsers > 0 ? 'clickable-count' : ''}`}
                              onClick={() => handleTotalUsersClick(item.corporateId, item.totalUsers || 0)}
                              style={{ 
                                cursor: item.totalUsers > 0 ? 'pointer' : 'default',
                                textDecoration: item.totalUsers > 0 ? 'underline' : 'none',
                                color: item.totalUsers > 0 ? '#14AE78' : 'inherit'
                              }}
                            >
                              {item.totalUsers || "N/A"}
                            </span>
                          </td>
                          
                          {/* Total Department - Clickable if > 0 */}
                          <td>
                            <span 
                              className={`total-count ${item.totalDepartment > 0 ? 'clickable-count' : ''}`}
                              onClick={() => handleTotalDepartmentClick(item.corporateId, item.totalDepartment || 0)}
                              style={{ 
                                cursor: item.totalDepartment > 0 ? 'pointer' : 'default',
                                textDecoration: item.totalDepartment > 0 ? 'underline' : 'none',
                                color: item.totalDepartment > 0 ? '#14AE78' : 'inherit'
                              }}
                            >
                              {item.totalDepartment || "N/A"}
                            </span>
                          </td>
                          
                          {/* Total Rule - Clickable if > 0 */}
                          <td>
                            <span 
                              className={`total-count ${item.totalRule > 0 ? 'clickable-count' : ''}`}
                              onClick={() => handleTotalRuleClick(item.corporateId, item.totalRule || 0)}
                              style={{ 
                                cursor: 'pointer', // Always clickable for rules
                                textDecoration: 'underline',
                                color: '#14AE78'
                              }}
                            >
                              {item.totalRule || "N/A"}
                            </span>
                          </td>
                          
                          <td className="actions-cell">
                            <div className="action-icons">
                              {/* Edit icon for corporate dashboard */}
                              <img 
                                 src={editIcon}
                                alt="View" 
                                onClick={() => handleBPUserDetails(item.corporateId)} 
                                className="bp-eye-icon"
                                style={{ cursor: "pointer" }} 
                                title="View Corporate Details"
                              />
                             
                                  {/* View details icon */}
                              <img 
                               
                                src={eyeTag}  
                                alt="Edit" 
                                onClick={() => handleEditCorporate(item.corporateId)} 
                                className="bp-eye-icon"
                                style={{ cursor: "pointer", marginRight: "10px" }} 
                                title="Go to Corporate Dashboard"
                              />
                              
                         
                             
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="no-results">
                          <div className="no-results-content">
                            {/* <img src={emotions7} alt="No results" /> */}
                            <p>No BP Found</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
};

export default CorporateListComponent;